import MakeTitle, {
  IMakeTitleProps,
} from 'app/shared/components/ModelReview/MakeTitle/MakeTitle';
import ModelSpecificCTA, {
  IModelSpecificCTAProps,
} from 'app/shared/components/ModelReview/ModelSpecificCTA/ModelSpecificCTA';
import { WrittenBy } from 'app/shared/components/ModelReview/WrittenBy/WrittenBy';
import {
  IRatingProps,
  Rating,
} from 'app/shared/components/ModelReview/Rating/Rating';
import TableOfContents, {
  ITableOfContentsProps,
} from 'app/shared/components/ModelReview/TableOfContents/TableOfContents';
import ReviewSection, {
  IReviewSectionProps,
} from 'app/shared/components/ModelReview/ReviewSection/ReviewSection';
import { ISearchPreviewBoxProps } from 'app/shared/components/ModelReview/SearchPreviewBox/SearchPreviewBox';
import CollapsibleReviewSection from 'app/shared/components/ModelReview/CollapsibleReviewSection/CollapsibleReviewSection';
import { WrapperSt } from 'app/shared/components/ModelReview/ModelReview.css';
import {
  IOtherModelsReviewsProps,
  OtherModelsReviews,
} from 'app/shared/components/ModelReview/OtherModelsReviews/OtherModelsReviews';
import Grid from '@heycar-uikit/grid';

export interface IModelReviewProps {
  makeTitle: IMakeTitleProps;
  modelSpecificCta: IModelSpecificCTAProps;
  rating: IRatingProps;
  tableOfContents: ITableOfContentsProps;
  overallReviewSection: IReviewSectionProps;
  searchPreview: ISearchPreviewBoxProps;
  onTheInsideReviewSection: IReviewSectionProps;
  drivingReviewSection: IReviewSectionProps;
  costToRunReviewSection: IReviewSectionProps;
  pricesReviewSection: IReviewSectionProps;
  otherModelsReviewsSection: IOtherModelsReviewsProps;
}

export const ModelReview = (props: IModelReviewProps) => {
  return (
    <WrapperSt>
      <Grid.Container>
        <Grid.Row>
          <Grid.Col>
            <Grid.Container>
              <MakeTitle {...props.makeTitle} />
              <ModelSpecificCTA {...props.modelSpecificCta} />
              <WrittenBy />
              <Rating {...props.rating} />
              <TableOfContents {...props.tableOfContents} />
              <ReviewSection {...props.overallReviewSection} />
            </Grid.Container>
          </Grid.Col>
        </Grid.Row>
      </Grid.Container>

      <Grid.Container>
        <Grid.Row>
          <Grid.Col>
            <Grid.Container>
              <CollapsibleReviewSection {...props.onTheInsideReviewSection} />
              <CollapsibleReviewSection {...props.drivingReviewSection} />
              <CollapsibleReviewSection {...props.costToRunReviewSection} />
              <CollapsibleReviewSection {...props.pricesReviewSection} />
              <OtherModelsReviews {...props.otherModelsReviewsSection} />
            </Grid.Container>
          </Grid.Col>
        </Grid.Row>
      </Grid.Container>
    </WrapperSt>
  );
};
